import { useBaseListView } from '@/common/view/useBaseListView';
import { duplicateService } from '@/services/duplicate';
import { useRoute } from 'vue-router';

export function useDuplicateCycleDeck() {
    const route = useRoute();
    const params = route.params;

    const { list, total, fetchList } = useBaseListView({
        request: duplicateService.cycle.getDeck,
        paramsBuilder: () => ({ ...params })
    });

    return { list, total, fetchList };
}
